import React, {useCallback, useEffect} from 'react';
import {addYears} from "date-fns";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {getEvaluationReportList} from "../../../api/evaluation/ReportService";
import {PageHeader} from "../../../components/PageHeader";
import useRequestData from "../../../hooks/useRequestData";
import {EvaluationReportListType} from "./subPages/EvaluationReportListType";
import Search from "../../../components/search/Search";
import {useParams} from "react-router-dom";

function EvaluationReportListContent({type, title}) {
    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    };

    const fetchList = useCallback((conditions, pageable) => {
        return getEvaluationReportList({...conditions, type}, pageable);
    }, [type]);

    const {newData, pageInfo, dataHook} =
        useRequestData(fetchList, initDate, `evaluation_${type}`);

    const {handleSearch, handlePageSizeChange, saveConditions, refresh} = dataHook;
    const searchDate = {
        startDate: saveConditions.startDate ?? initDate.startDate,
        endDate: saveConditions.endDate ?? initDate.endDate,
    };

    useEffect(() => {
        handleSearch({type});
    }, [type]);

    return (
        <div className="common-container container-height-full">
            <PageHeader header={title.header} indicator={title.indicator}/>
            <div className="container-height">
                <Search
                    refresh={refresh}
                    entity={`evaluation_${type}`}
                    searchConditions={saveConditions}
                    handleSearch={handleSearch}
                    handlePageSizeChange={handlePageSizeChange}
                    pageInfo={pageInfo}
                    size
                    date={searchDate}
                    searchBar={{placeHolder: '제목'}}
                />
                <EvaluationReportListType
                    data={newData}
                    pageInfo={pageInfo}
                    type={type}
                    dataHook={dataHook}
                    deleteMessage={`삭제할 ${title.header}를 선택해주세요.`}
                />
            </div>
        </div>
    );
}

function EvaluationReportList() {
    const {type} = useParams();
    const title = {
        header: type === "inspection" ? "점검종합보고서" : type === "incident" ? "장애종합보고서" : type === "work" ? "작업종합보고서" : "요청종합보고서",
        indicator: type === "inspection" ? "평가관리/보고서 > 업무보고서 > 점검종합보고서" :
            type === "incident" ? "평가관리/보고서 > 업무보고서 > 장애종합보고서" :
                type === "work" ? "평가관리/보고서 > 업무보고서 > 작업종합보고서" :
                    "서비스요청 > 요청종합보고서",
    };

    return <EvaluationReportListContent key={type} type={type} title={title} />;
}

export {EvaluationReportList};